import { Flex, type FlexProps } from '@/ui';

export const PanelContent = (props: FlexProps) => {
  return <Flex direction="column" flex="1" overflowY="auto" p="8" {...props} />;
};
